// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ydf6","select":"styles_select__1bqIU"};